import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TableDataCell from './TableDataCell';

const StyledDataCell = styled(TableDataCell)`
  vertical-align: middle;
  text-align: center;
`;

const StyledSelect = styled.select`
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0px;
  color: ${(props) => props.theme.fontColor};

  &:hover {
    cursor: pointer;
  }

  &:focus, &:focus-visible {
    outline: unset;
    border: 1px solid transparent;
  }

`;

const TableFieldMenuCell = ({
  id,
  cellKey,
  disabled,
  rowId,
  rowIndex,
  onAddBelow,
  onDuplicate,
  onMoveUp,
  onMoveDown,
  onDelete,

  width,
  fontColor,
  primaryColor,
  padding,
  borderColor,
  borderWidth,
  backgroundColor,

}) => {

  const handleAction = (e) => {
    const option = e.target.value;

    if (option === 'addBelow') onAddBelow(rowId, rowIndex);
    if (option === 'duplicate') onDuplicate(rowId, rowIndex);
    if (option === 'moveUp') onMoveUp(rowId, rowIndex);
    if (option === 'moveDown') onMoveDown(rowId, rowIndex);
    if (option === 'delete') onDelete(rowId, rowIndex);

  };

  return (
    <StyledDataCell
      key={cellKey}
      data-testid={`${id}-${rowId}-menu-cell`}
      {...{
        width,
        fontColor,
        padding,
        borderColor,
        borderWidth,
        backgroundColor,
        primaryColor
      }}
    >
      <StyledSelect
        theme={{
          fontColor,
          primaryColor
        }}
        value="cog"
        disabled={disabled}
        onChange={handleAction}
        data-testid={`${id}-${rowId}-menu-cell-select`}
      >
        <option value="cog" />
        <option value="addBelow">Insert Below</option>
        <option value="duplicate">Duplicate</option>
        <option value="moveUp">Move Up</option>
        <option value="moveDown">Move Down</option>
        <option value="delete">Delete</option>
      </StyledSelect>
    </StyledDataCell>
  );

};

TableFieldMenuCell.propTypes = {
  id: PropTypes.string,
  cellKey: PropTypes.string,
  disabled: PropTypes.bool,
  rowId: PropTypes.string,
  rowIndex: PropTypes.number,
  onAddBelow: PropTypes.func,
  onDuplicate: PropTypes.func,
  onMoveUp: PropTypes.func,
  onMoveDown: PropTypes.func,
  onDelete: PropTypes.func,
  width: PropTypes.number,
  padding: PropTypes.number,
  borderColor: PropTypes.string,
  borderWidth: PropTypes.number,
  backgroundColor: PropTypes.string,
};

export default TableFieldMenuCell;
